import { computed } from "vue";
import { useRoute } from "vue-router";
import { demos } from "@/views/user/demos/demosData.js";
import { tutorialByRoute } from "@/config/tutorialContextMap";
import { useCursoStore } from "@/store/cursoStore";
import { authService } from "@/services/authService";
const ROLES_DIRECTIVOS = ["president", "secretary", "treasurer"];
const AUTH_ROUTE_NAMES = new Set([
    "login",
    "register",
    "password-recovery",
    "magic-link",
    "callback",
]);
function puedeVerDemo(demo, esDirectivo) {
    if (demo.categoria === "apoderados")
        return true;
    return esDirectivo;
}
export function getYoutubeThumb(videoUrl) {
    const match = String(videoUrl).match(/embed\/([^?&/]+)/);
    const id = match?.[1] ?? "";
    return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
}
export function useContextualTutorials() {
    const route = useRoute();
    const cursoStore = useCursoStore();
    const esDirectivo = computed(() => {
        const curso = cursoStore.getCursoData();
        const roles = Array.isArray(curso?.roles) ? curso.roles : [];
        return roles.some((role) => ROLES_DIRECTIVOS.includes(String(role)));
    });
    const contextualDemos = computed(() => {
        const routeName = typeof route.name === "string" ? route.name : "";
        if (!routeName || AUTH_ROUTE_NAMES.has(routeName))
            return [];
        const demoIds = tutorialByRoute[routeName];
        if (!demoIds?.length)
            return [];
        const idSet = new Set(demoIds);
        const byId = new Map(demos.map((demo) => [demo.id, demo]));
        return demoIds
            .map((id) => byId.get(id))
            .filter((demo) => Boolean(demo))
            .filter((demo) => idSet.has(demo.id))
            .filter((demo) => puedeVerDemo(demo, esDirectivo.value));
    });
    const showTutorialFab = computed(() => authService.isAuthenticated() && contextualDemos.value.length > 0);
    return {
        contextualDemos,
        showTutorialFab,
    };
}
